<template>
  <div>
    <div v-if="show" class="labels clearfix">
      <span class="title">已筛选</span>
      <div class="clearfix" style="padding: 8px 0 0 10px">
        <span @click="removeLabel(item, index)" class="filter-label" v-for="(item, index) in locationLabels" :key="item.value">
          {{item.value}}
          <span>x</span>
        </span>
        <span @click="removeLabel(item, index)" class="filter-label" v-for="(item, index) in industryLabels" :key="item.value">
          {{item.value}}
          <span>x</span>
        </span>
        <span @click="removeLabel(item, index)" class="filter-label" v-for="(item, index) in subindustryLabels" :key="item.value">
          {{item.value}}
          <span>x</span>
        </span>
        <span @click="removeLabel(item, index)" class="filter-label" v-for="(item, index) in labels" :key="item.value">
          {{item.value}}
          <span>x</span>
        </span>
        <span @click="removeLabel(item, index)" class="filter-label" v-for="(item, index) in subLabels" :key="item.value">
          {{item.value}}
          <span>x</span>
        </span>
        <span @click="clear" class="clear-label">
          清除条件
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import * as options from '../../common/optionMap';
import filter from '../../filter/index'
import { filterCapital,filterEstablishDate ,getReversibleCityName} from '../../common/utils';

export default {
  props: ['value','subUserList'],
  data() {
    return {
      contactMap: {
        '1': '有手机',
        '2': '有固话',
        '3': '有邮箱',
        '4': '有QQ',
        '5':'无联系方式'
      },
      exportMap: {
        '1': '已导出',
        '2': '未导出',
      },
      clickedMap: {
        '1': '已查看',
        '2': '未查看',
      },
      locationLabels: [],
      industryLabels: [],
      labels: [],
      subLabels:[],
      subindustryLabels:[]
    };
  },
  watch: {
    value: {
      handler: function(val) {
        this.generateLabels();
      },
      deep: true
    }
  },
  computed: {
    show() {
      return (
        this.locationLabels.length > 0 ||
        this.industryLabels.length > 0 ||
        this.labels.length > 0||this.subLabels.length > 0 ||
        this.subindustryLabels.length > 0
      );
    }
  },
  methods: {
    generateLabels() {
      let labels = [];
      let keywordLabels = [];
      let locationLabels = [];
      let industryLabels = [];
      let subindustryLabels = [];
      let subLabels = [];
      if (this.value) {
        if (this.value.location && this.value.location.length > 0) {
          locationLabels = [{
              key: 'location',
              value: filter.regionTostring(this.value.location[0])
            }]
        }
        if (this.value.industryshort && this.value.industryshort.length > 0) {
          let industryshorts = this.value.industryshort.map(item => {
          let reserveMath = options.industryMapMathResver[item];
            return {
              key: 'industry',
              value: '所属行业: ' + options.industryMap[reserveMath]
            };
          });
          industryLabels = [...industryLabels, ...industryshorts];
        }
        //二级
        if (this.value.secindustryshort && this.value.secindustryshort.length > 0) {
          let secindustryshort = this.value.secindustryshort.map(item => {
            return {
              key: 'secindustryshort',
              value: '所属行业: ' + options.industrySubMap[item]
            };
          });
          subindustryLabels = [...subindustryLabels, ...secindustryshort];
        }
        if (this.value.registercapital !== '0') {
          labels.push({
            key: 'capital',
            value: '注册资本: ' + filterCapital(this.value.registercapital)
          });
        }
        if (this.value.establishment !== '0') {
          labels.push({
            key: 'date',
            value:
              '成立年限: ' + filterEstablishDate(this.value.establishment)
          });
        }
        if (this.value.contact !== '0') {
          labels.push({
            key: 'contact',
            value: '联系方式: ' + this.contactMap[this.value.contact]
          });
        }
        if (this.value.enttype !== '0') {
          labels.push({
            key: 'enttype',
            value: '企业类型: ' + this.enttypeMap[this.value.enttype]
          });
        }
        if (this.value.entstatus !== '0') {
          labels.push({
            key: 'entstatus',
            value: '营业状态:' + options.entstatusMap[this.value.entstatus]
          });
        }
        if (this.value.isExported !== '0') {
          labels.push({
            key: 'isExported',
            value: '导出情况:' + this.exportMap[this.value.isExported]
          });
        }
        if (this.value.isClicked !== '0') {
          labels.push({
            key: 'isClicked',
            value: '查看情况:' + this.clickedMap[this.value.isClicked]
          });
        }
        if (this.value.userids && this.value.userids.length > 0) {
          let sublist = this.value.userids.map(item => {
            let label = '';
            this.subUserList.forEach((e,i)=>{
                if(e.value==item){
                    label = e.label;
                }
             });
            if(!label) return ;
            return {
              key: 'userids',
              value: '操作人: ' + label
            };
          });
          subLabels = [...subLabels, ...sublist];
        }
      }
      this.labels = labels;
      this.locationLabels = locationLabels;
      this.industryLabels = industryLabels;
      this.subLabels = subLabels;
      this.subindustryLabels = subindustryLabels;
    },
    removeLabel(item, index) {
      let clone = { ...this.value };
      if (item.key === 'location') {
        // if (this.value.location.length != 1) {
        //   clone.location.splice(index, 1);
        //   this.$emit('input', clone);
        // } else {
          clone.location = [];
          this.$emit('input', clone);
        // }
      }
      if (item.key === 'industry') {
        if (this.value.industryshort.length != 1) {
          clone.industryshort.splice(index, 1);
          this.$emit('input', clone);
        } else {
          clone.industryshort = [];
          this.$emit('input', clone);
        }
      }
      if (item.key === 'capital') {
        clone.registercapital = '0';
        this.$emit('input', clone);
      }

      if (item.key === 'date') {
        clone.establishment = '0';
        this.$emit('input', clone);
      }
      if (item.key === 'contact') {
        clone.contact = '0';
        this.$emit('input', clone);
      }
      if (item.key === 'enttype') {
        clone.enttype = '0';
        this.$emit('input', clone);
      }
      if (item.key === 'entstatus') {
        clone.entstatus = '0';
        this.$emit('input', clone);
      }
      if (item.key === 'isExported') {
        clone.isExported = '0';
        this.$emit('input', clone);
      }
      if (item.key === 'isClicked') {
        clone.isClicked = '0';
        this.$emit('input', clone);
      }
      if (item.key === 'userids') {
        if (this.value.userids.length != 1) {
          clone.userids.splice(index, 1);
          this.$emit('input', clone);
        } else {
          clone.userids = [];
          this.$emit('input', clone);
        }
      }
      if (item.key === 'secindustryshort') {
        if (this.value.secindustryshort.length != 1) {
          clone.secindustryshort.splice(index, 1);
          this.$emit('input', clone);
        } else {
          clone.secindustryshort = [];
          this.$emit('input', clone);
        }
      }
    },
    clear() {
      this.$emit('input', {
        location: [],
        industryshort: [],
        registercapital: '0',
        establishment: '0',
        contact: '0',
        enttype: '0',
        entstatus: '0',
        userids:[],
        isExported:'0',
        isClicked:'0',
        secindustryshort:[]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.labels {
  padding: 8px 10px;
  background: #ffffff;
  // border-radius: 4px;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  min-height: 58px;
  padding-left: 102px;
  border: 1px solid var(--table-division-color);
  border-top: none;

  .title {
    color: #727273;
    margin-top: 4px;
    width: 56px;
    position: absolute;
    display: block;
    left: 20px;
    top: 14px;
    &:after {
      position: absolute;
      content: '';
      width: 1px;
      height: 18px;
      background: #f1f1f1;
      right: -20px;
    }
  }
  &.more-top {
    .title {
      top: 18px;
    }
  }
  .filter-label {
    color: var(--text-content-color);
    padding: 1px 2px 1px 5px;
    border: 1px solid #dee7eb;
    margin-right: 10px;
    font-size: 14px;
    margin-bottom: 10px;
    float: left;
    transition: all 0.2s;
    &:hover {
      border: 1px solid var(--theme-color);
      cursor: pointer;
      span {
        background: var(--theme-color);
      }
    }
    span {
      vertical-align: 1px;
      height: 100%;
      transition: all 0.2s;
      background: #ddebeb;
      display: inline-block;
      color: #fff;
      padding: 0 5px;
      padding-bottom: 2px;
    }
  }
  .clear-label {
    float: left;
    color: #999;
    cursor: pointer;
    margin-top: 3px;
    &:hover {
      color: var(--theme-color);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/global/labels.vue